import React, { useCallback } from "react";
import { BiArrowFromBottom } from "react-icons/bi";
import { version } from "../../../package.json";

interface Props {
  body: HTMLDivElement | null;
}

const Footer = ({ body }: Props) => {
  const scrollToTop = useCallback(() => {
    body?.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, [body]);

  return (
    <footer>
      <button type="button" onClick={scrollToTop}>
        <BiArrowFromBottom size={18} />
        <p className="footerText">Back to Top</p>
      </button>
      <p>WorkOutLoud Venue v{version}</p>
      <style jsx>
        {`
          p {
            font-size: 0.8em;
            color: gray;
            padding: 0;
            margin: 0;
          }
          footer {
            background: #f8f9fa;
            opacity: 0.8;
            box-shadow: 0 0 16px rgba(166, 171, 189, 0.6);
            height: 59px;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
          }
          button {
            height: 100%;
            background: none;
            border: none;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          .footerText {
            padding: 0 0 0 5px;
            font-weight: normal;
            font-size: 0.9rem;
            color: #343434;
          }
        `}
      </style>
    </footer>
  );
};
export default Footer;
